import axios from './axios';

/**
 * Create a Stripe Checkout Session
 */
export const createCheckoutSession = async (bookingData) => {
    const response = await axios.post('/stripe/checkout', bookingData);
    return response.data;
};

/**
 * Verify payment after redirect from Stripe
 */
export const verifyPayment = async (sessionId, bookingId) => {
    const response = await axios.post('/stripe/verify', {
        session_id: sessionId,
        booking_id: bookingId,
    });
    return response.data;
};
